import { cn } from '@commenda/utils';
import React from 'react';

export interface SettingFieldProps {
  title: string;
  description?: string;
  action?: React.ReactNode;
  children: React.ReactNode;
  className?: string;
}

export const SettingField = ({
  title,
  description,
  action,
  children,
  className,
}: SettingFieldProps) => (
  <div className={cn('flex w-full flex-col gap-2xl', className)}>
    <div className="flex w-full items-start gap-lg px-lg">
      <div className="flex min-w-0 flex-1 flex-col gap-xxs">
        <span className="txt-medium-medium text-text-primary">{title}</span>
        {description ? (
          <span className="txt-extra-small-regular text-text-tertiary">
            {description}
          </span>
        ) : null}
      </div>
      {action}
    </div>
    {children}
  </div>
);

export const SettingFieldReadOnly = ({
  value,
  className,
}: {
  value: string;
  className?: string;
}) => (
  <p
    className={cn(
      'txt-small-regular min-h-10 w-full whitespace-pre-wrap rounded-xl border-1/2 border-border-secondary bg-bg-primary px-xl py-md text-text-primary',
      'shadow-[0px_1px_1.5px_0px_rgba(18,18,18,0.06),0px_1px_1px_0px_rgba(18,18,18,0.1)]',
      className
    )}
  >
    {value}
  </p>
);

export const SettingFieldControlCard = ({
  children,
  className,
}: {
  children: React.ReactNode;
  className?: string;
}) => (
  <div
    className={cn(
      'flex w-full items-center gap-md rounded-xl border-1/2 border-border-secondary bg-bg-primary p-lg',
      'shadow-[0px_1px_1.5px_0px_rgba(18,18,18,0.06),0px_1px_1px_0px_rgba(18,18,18,0.1)]',
      className
    )}
  >
    {children}
  </div>
);
